import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';

class SrTourCopyMlsNumber extends Component {
  static propTypes = {
    mlsNumber: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      showClickedTooltip: false,
    };
    this._unmounting = false;
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  _onCopyMlsNumberClick = (e) => {
    const { mlsNumber } = this.props;
    e.preventDefault();
    e.stopPropagation();

    copyToClipboard(mlsNumber);

    this.setState({
      showClickedTooltip: true,
    });
    setTimeout(() => {
      if (!this._unmounting) {
        this.setState({
          showClickedTooltip: false,
        });
      }
    }, 2000);
  };

  render() {
    const { mlsNumber } = this.props;
    const { showClickedTooltip } = this.state;

    if (!mlsNumber) {
      return null;
    }

    return (
      <span onClick={this._onCopyMlsNumberClick} className="copyMlsNumber">
        <span className="secondaryAction">
          {mlsNumber}
          <span
            className={classnames(
              'copiedMessage',
              'mlsCopyMessage',
              showClickedTooltip && 'clicked',
            )}
          >
            Copied!
          </span>
        </span>
      </span>
    );
  }
}

SrTourCopyMlsNumber.displayName = 'SrTourCopyMlsNumber';

export default SrTourCopyMlsNumber;
